<template>
    <ThSelect
        v-model="value"
        :options="codes"
        legend="Country code"
        placeholder="Country code"
    />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { entries } from 'remeda'
import { countryPhoneCodes } from '@/helpers/country-phone-codes'
import { useTranslator } from '@/i18n'

import ThSelect from './ThSelect.vue'
import { useCountryPlugin } from '@/plugins/country.ts'

const value = defineModel<string>('value', {
    required: true,
})

const { getCountryName } = useTranslator()
const { countries } = useCountryPlugin()

const codes = computed(() => [
    ...countries.value.flatMap((item) =>
        item.countries.map((country) => ({
            value: countryPhoneCodes[country.isoCode],
            label: `${getCountryName(country.isoCode)} ${countryPhoneCodes[country.isoCode]}`,
        }))
    ),
    ...entries(countryPhoneCodes)
        .map(([country, code]) => ({
            value: code,
            label: `${getCountryName(country)} ${code}`,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
])
</script>
